<template>
  <sui-card class="state-card">
    <sui-card-content class="compact">
      <b>Serving</b>
    </sui-card-content>
    <sui-card-content>
      <div class="no-services" v-if="!existedServices.length">
        No services<span v-show="!member.isOwner"> or you don't have permissions to see them</span>
      </div>
      <div class="services" v-if="existedServices.length">
        <div class="service" v-for="srv in existedServices" :key="srv.id">
          <Logo :entity="servicesById[srv.id]" inline />
          <router-link class="service-link" :to="`/services/${servicesById[srv.id].name}`" title="Open service">
            {{servicesById[srv.id].name}}
          </router-link>
          <i class="cog grey link fitted icon" :class="{disabled: isDisabled}" title="Open config" @click.stop.prevent="openConfig(srv.id)" />
        </div>
      </div>
    </sui-card-content>
    <sui-button fluid attached="bottom" size="mini" :disabled="isDisabled" @click="$modals.updateService.open(service, 'updatingServices')">Edit</sui-button>
  </sui-card>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'ServiceServicesCard',
    props: {
      service: {
        type: Object,
        required: true,
      },
    },
    computed: {
      ...mapGetters(['actionsById', 'servicesById', 'member']),
      actions() {
        return this.actionsById[this.service.id]
      },
      status() {
        return this.service._status
      },
      isOnline() {
        return this.service._isOnline
      },
      isOffline() {
        return this.service._isOffline
      },
      isDeployed() {
        return this.service._isDeployed
      },
      inProgress() {
        return this.service._inProgress
      },
      isDisabled() {
        return !this.isDeployed || this.inProgress || !this.actions.serviceUpdate
      },
      existedServices() {
        return this.service.services.filter(service => this.servicesById[service.id])
      },
    },
    methods: {
      openConfig(serviceId) {
        this.$modals.updateService.open(this.service, 'updatingServices', () => {
          this.$modals.updateService.$refs.formService.$refs.services.openConfig(serviceId)
        })
      },
    },
  }
</script>

<style scoped>
  .state-content { position: relative; }
  .no-services { white-space: normal; }
  .services { position: absolute; left: 0; top: 0; right: 0; bottom: 0; overflow-x: hidden; overflow-y: auto; display: flex; flex-direction: column; }
  .service { display: flex; align-items: center; justify-content: space-between; width: 100%; padding: .3em; border-bottom: 1px solid #eee; white-space: nowrap; text-align: left; }
  .service-link { display: flex; flex: 1; overflow: hidden; }
  .cog { padding-left: .2em; }
</style>
